import React, { useState, useEffect } from 'react';
import {
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
  InputAdornment,
  IconButton,
  Divider
} from '@mui/material';
import { Visibility, VisibilityOff, Email, Lock } from '@mui/icons-material';
import { useAuth } from '../../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { GoogleLoginButton } from '../../GoogleLoginButton';
import styles from './Login.module.css';
import logoBlackTransparent from '/logo-black-transparent.png';

export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  
  const { login, isLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Redireciona se já estiver autenticado
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/finances', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Por favor, preencha todos os campos');
      return;
    }

    const result = await login(email, password);
    
    if (result.success) {
      // Força o redirecionamento imediatamente após o login
      navigate('/finances', { replace: true });
    } else {
      setError(result.message || 'Erro ao fazer login');
    }
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleGoogleSuccess = () => {
    navigate('/finances', { replace: true });
  };

  const handleGoogleError = (errorMessage: string) => {
    setError(errorMessage);
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginWrapper}>
        <Paper className={styles.loginPaper} elevation={3}>
          <Box className={styles.loginHeader}>
            <img style={{ width: '200px', height: 'auto' }} src={logoBlackTransparent} alt="Logo Reactor Finances" />
            <Typography variant="body1" className={styles.subtitle}>
              Faça login para acessar sua conta
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" className={styles.errorAlert}>
              {error}
            </Alert>
          )}

          {/* Botão de login com Google */}
          <GoogleLoginButton
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
            disabled={isLoading}
          />

          {/* Divisor */}
          {/* <Box className={styles.dividerContainer}>
            <Divider className={styles.divider}>
              <Typography variant="body2" color="textSecondary">
                ou
              </Typography>
            </Divider>
          </Box>

          <form onSubmit={handleSubmit} className={styles.loginForm}>

            <TextField
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email color="action" />
                  </InputAdornment>
                ),
              }}
              className={styles.textField}
            />

            <TextField
              fullWidth
              label="Senha"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={isLoading}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock color="action" />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleTogglePasswordVisibility}
                      edge="end"
                      disabled={isLoading}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              className={styles.textField}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={isLoading}
              className={styles.loginButton}
            >
              {isLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'Entrar'
              )}
            </Button>
          </form> */}

          {/* <Box className={styles.loginFooter}>
            <Typography variant="body2" color="textSecondary">
              Credenciais de teste:
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Email: admin@test.com | Senha: 123456
            </Typography>
          </Box> */}
        </Paper>
      </div>
    </div>
  );
};